import WEEK_DAYS from './weekDays';
import CONTACT_TYPES from './contactTypes';
import USER_STATUS from './userStatus';
import RESPONSE_STATUS from './responseStatus';
import TABLE_FLOORS from './tableFloors';
import TABLE_LOCATIONS from './tableAreas';
import CAFE_STATUS from './cafeStatus';
import BANK_STATUS from './bankStatus';
import BANK_NAMES from './bankNames';
import FINANCIAL_TRANSACTION_TYPES from './financialTransactionTypes';
import MONEY_UNITS from './moneyUnits';
import SETTING_KEYS from './settingKeys';
import MARRIAGE_STATUS from './marriageStatus';
import GENDERS from './genders';
import INTRODUCED_CAFE_STATUS from './introducedCafeStatus';
import PERMISSIONS from './permissions';
import COMMENTS_RESPONSES_TYPE from './commentsResponsesType';
import COMMENTS_RESPONSES_PERMISSION from './commentsResponsesPermission';
import ROLES from './roles';
import MEAL_PORTIONS from './mealPortions';
import RESERVATION_STATUS from './reservationStatus';
import RESERVATION_TYPES from './reservationTypes';
import CAFE_RESERVATION_DAY_TIMES from './cafeReservationDayTimes';
import CAFE_RESERVATION_HOURS from './cafeReservationHours';
import CAFE_RESERVATION from './cafeReservations';
import CURRENCY from './currency';
import DISCOUNT_CODES_STATUS from './discountsStatus';
import DISCOUNT_CODES_TYPES from './discountTypes';
import DISCOUNT_CODE_ALLOWED_USERS from './discountAllowedUsers';
import DISCOUNT_CODE_USERS_STATUS from './discountCodeUsersStatus';
import CAFE_DISCOUNT_VALUE_TYPES from './cafeDiscountValueTypes';
import TICKETS_STATUS from './ticketsStatus';
import TICKET_TYPES from './ticketTypes';
import CAFE_DISCOUNT_STATUS from './cafeDiscountStatus';
import SOCKET_IO_EVENTS from './socketIoEvents';
import RSEE_DISCOUNTS_STATUS from './rseeDiscountsStatus';
import EVENT_STATUS from './event_status';
import MESSAGE_RECEIVERS from './message_receivers';
import MESSAGE_VIEW_STATUS from './messageViewStatus';
import MESSAGE_PUBLISH_STATUS from './messagePublishStatus';
import CHECKOUT_TYPES from './checkoutTypes';
import PAY_TYPES from './payTypes';
import COMMENT_STATUS from './commentStatus';
import MAX_LENGTH from './maxLength';
import INVOICE_STATUS from './invoiceStatus';
import INCOMMING_RESERVE from './incoming-reserve';
import SHEMATIC_RESERVATION from './schematicReservation';
import SCHEDULE_WEEK_DAYS from './scheduleWeekDays';
import RSEE_STOCK_TYPE from './rseeStockType';
import CAFE_TYPE from './cafesType';
import TAKEAWAY_PAYMENT_STATUS from './takeawayPaymentStatus';
import PACKAGE_STATUS from './packageStatus';
import GIFT_CHAIR_ALLOWED_USERS from './giftChairAllowedUsers';
import RESERVE_DURATION from './reserveDuration';
import CAFE_TABLE_STATUS from './cafeTableStatus';

export default {
  WEEK_DAYS,
  CONTACT_TYPES,
  USER_STATUS,
  RESPONSE_STATUS,
  TABLE_FLOORS,
  TABLE_LOCATIONS,
  CAFE_STATUS,
  BANK_STATUS,
  BANK_NAMES,
  FINANCIAL_TRANSACTION_TYPES,
  MONEY_UNITS,
  SETTING_KEYS,
  MARRIAGE_STATUS,
  GENDERS,
  INTRODUCED_CAFE_STATUS,
  PERMISSIONS,
  COMMENTS_RESPONSES_TYPE,
  COMMENTS_RESPONSES_PERMISSION,
  ROLES,
  MEAL_PORTIONS,
  RESERVATION_STATUS,
  RESERVATION_TYPES,
  CAFE_RESERVATION_DAY_TIMES,
  CAFE_RESERVATION_HOURS,
  CAFE_RESERVATION,
  CAFE_TABLE_STATUS,
  CURRENCY,
  DISCOUNT_CODES_STATUS,
  DISCOUNT_CODES_TYPES,
  DISCOUNT_CODE_ALLOWED_USERS,
  DISCOUNT_CODE_USERS_STATUS,
  CAFE_DISCOUNT_VALUE_TYPES,
  TICKETS_STATUS,
  TICKET_TYPES,
  CAFE_DISCOUNT_STATUS,
  SOCKET_IO_EVENTS,
  RSEE_DISCOUNTS_STATUS,
  EVENT_STATUS,
  MESSAGE_RECEIVERS,
  MESSAGE_PUBLISH_STATUS,
  MESSAGE_VIEW_STATUS,
  CHECKOUT_TYPES,
  PAY_TYPES,
  COMMENT_STATUS,
  MAX_LENGTH,
  INVOICE_STATUS,
  INCOMMING_RESERVE,
  SHEMATIC_RESERVATION,
  SCHEDULE_WEEK_DAYS,
  RSEE_STOCK_TYPE,
  CAFE_TYPE,
  TAKEAWAY_PAYMENT_STATUS,
  PACKAGE_STATUS,
  GIFT_CHAIR_ALLOWED_USERS,
  RESERVE_DURATION,
};
